var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Received"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Received",
    clipPath: "url(#clip-Received)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35783",
    "data-name": "Path 35783",
    d: "M7.16,10.76l4.23-4.23-.84-.84L7.16,9.08,5.45,7.37l-.84.84,2.55,2.55ZM8,14a5.839,5.839,0,0,1-2.34-.473A5.987,5.987,0,0,1,2.473,10.34a6.027,6.027,0,0,1,0-4.68A5.987,5.987,0,0,1,5.66,2.473a6.027,6.027,0,0,1,4.68,0A5.991,5.991,0,0,1,13.528,5.66a6.031,6.031,0,0,1,0,4.68,5.991,5.991,0,0,1-3.187,3.188A5.832,5.832,0,0,1,8,14Z",
    transform: "translate(-2 -2)",
    fill: "#437709"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportReceived);
export default __webpack_public_path__ + "static/media/Icon_ReportReceived.42a6f58f69d9dce45a5f7a803ebded89.svg";
export { ForwardRef as ReactComponent };